<template>
    <CCard >      
      <CCardBody>       
        <CRow style="margin-left: 0px;margin-right: 0px;">        
          <CCol sm="8" lg="8" style="border:1px rgb(206, 210, 216) solid;" >  
            <div class="content-wrapper" style="padding-top: 15px; padding-bottom: 15px;">
              <div id="app">                
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas_list' height='300' :allowExcelExport='true'
                    :allowPaging='true' :allowSorting='true' :queryCellInfo='onQueryCellInfo'
                    :toolbar='toolbar' :pageSettings='pageSettings' >                             
                    <e-columns>                
                        <e-column field='ua' headerText='採購單號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>              
                        <e-column field='ub' headerText='驗收單號' width='140' :isPrimaryKey='true'></e-column>          
                        <e-column field='f_no' headerText='料號' width='120'></e-column>   
                        <e-column field='f_name' headerText='料名' width='200'></e-column>   
                        <e-column field='quity' headerText='數量' width='120'></e-column>   
                        <e-column field='unit' headerText='單位' width='120'></e-column>   
                        <e-column field='f_date' headerText='預計交貨日' width='120'></e-column> 
                        <e-column field='invoice_month' headerText='帳款月' width='120'></e-column>   
                        <e-column field='amount_total' headerText='金額合計' width='120' textAlign='Right'></e-column> 
                        <e-column field='not_taxed_amount' headerText='未稅金額' width='120' textAlign='Right'></e-column> 
                        <e-column field='taxed_amount' headerText='稅額合計' width='120' textAlign='Right'></e-column> 
                        <e-column field='ub_quity' headerText='驗收數量' width='120' textAlign='Right'></e-column> 
                        <e-column field='bad_quity' headerText='不良品數' width='120' textAlign='Right'></e-column> 
                        <e-column field='ub_date' headerText='驗收日期' width='120' textAlign='Right'></e-column> 
                        <e-column field='ub_input' headerText='驗收入庫' width='120' textAlign='Right'></e-column>   
                        <e-column field='ub_pay_qut' headerText='付款數量' width='120' textAlign='Right'></e-column>   
                        <e-column field='c_no' headerText='廠商編號' width='120'></e-column>   
                        <e-column field='c_name' headerText='廠商名稱' width='200'></e-column>
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>            
          </CCol>  
          <CCol sm="4" lg="4" style="border:1px rgb(206, 210, 216) solid;" >    
            <ejs-accumulationchart style='display:block' :theme='theme2' align='center' id='chartcontainer2' :title="title3"
              :chartArea='chartArea2' :legendSettings='legendSettings2'  :pointRender='pointRender2'  :centerLabel='centerLabel2' :enableBorderOnMouseMove='false'>
              <e-accumulation-series-collection>
                  <e-accumulation-series :dataSource='datas_proportion' :border='border2' xName='name' :radius='radius2' yName='proportion' :startAngle='startAngle2' :dataLabel='dataLabel2'
                   innerRadius='65%'> </e-accumulation-series>               
              </e-accumulation-series-collection>
          </ejs-accumulationchart>
          </CCol>
          <CCol sm="12" lg="12" style="border:1px rgb(206, 210, 216) solid;" >  
            <div class="sb-button-group-section" style="text-align: center; padding-top: 10px ;">
              <div id="sb-button-group-control">              
                <div id="textonly" class="e-btn-group" style="padding-bottom: 5px; text-align: center;">
                    <input type="radio" id="left" name="align" value="left" />
                    <label class="e-btn" for="left" @click='onClickUnitPrice'>採購單價</label>
                    <input type="radio" id="center" name="align" value="center" />
                    <label class="e-btn" for="center" @click='onClickTotalPrice'>採購總價</label>
                    <!--<input type="radio" id="right" name="align" value="right" />
                    <label class="e-btn" for="right" @click='onClickAmount'>採購金額</label>    -->
                    <input type="radio" id="count" name="align" value="count" />
                    <label class="e-btn" for="count" @click='onClickQuity'>採購數量</label>
                </div>
              </div>  
            </div>
            <ejs-chart style='display:block' :theme='theme3' align='center' id='chartcontainer3' :primaryXAxis='primaryXAxis3' :primaryYAxis='primaryYAxis3'
                :tooltip='tooltip3' :chartArea='chartArea3' :legendSettings='legendSettings2' >
                <e-series-collection>
                   <e-series v-for="(series, index) in this.datas_header" :key="index"
                      :dataSource="datas_chat"
                      type="Column"
                      :xName="series.xName"
                      :yName="series.yName"
                      :name="series.name"/>                 
                </e-series-collection>
            </ejs-chart>

             <ejs-chart style='display:block' :theme='theme3' align='center' id='chartcontainer3' :primaryXAxis='primaryXAxis3' :primaryYAxis='primaryYAxis3'
                :tooltip='tooltip3' :chartArea='chartArea3' :width='width3' :legendSettings='legend3' >
                <e-series-collection>
                   <e-series v-for="(series, index) in this.datas_header" :key="index"
                      :dataSource="datas_chat"
                      type="Spline"
                      :xName="series.xName"
                      :yName="series.yName"
                      :name="series.name"/>
                    <!--<e-series :dataSource='seriesData3' type='Spline' xName='x' yName='y1' name='酢戀 (含格套板)' width=2  > </e-series>-->
                 
                </e-series-collection>
            </ejs-chart>

           
          </CCol>
        </CRow>
      </CCardBody>   
    </CCard>
  </template>
  <script>
    import Vue from "vue";
    import { Browser } from '@syncfusion/ej2-base';
    import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, PieSeries, AccumulationLegend, AccumulationDataLabel, AccumulationTooltip ,
        ChartComponent, SeriesDirective, SeriesCollectionDirective, StepLineSeries, ColumnSeries, Legend, Tooltip, DateTime, Category, Highlight, ChartAnnotation } from "@syncfusion/ej2-vue-charts";
    import { loadChartTheme } from "./../dashboard/theme-color";
    import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";

    import { loadAccumulationChartTheme, donutPointRender } from "./../dashboard/theme-color";

  let theme = loadChartTheme();
  let theme2 = loadAccumulationChartTheme();
  Vue.use(GridPlugin);  

  export default {
    components: {  
      'ejs-chart': ChartComponent,
      'e-series-collection': SeriesCollectionDirective,
      'e-series': SeriesDirective,
      'ejs-accumulationchart': AccumulationChartComponent,
      'e-accumulation-series-collection': AccumulationSeriesCollectionDirective,
      'e-accumulation-series': AccumulationSeriesDirective
    },
    data: function() {
      return {
        datas_list: null, datas_proportion: null, datas_header: null, 
        datas_chat: null, datas_unit_price: null, datas_total_price: null, datas_amount: null, datas_quity: null,
        max_unit_price: null, max_total_price: null, max_amount: null, max_quity: null,
        toolbar: [{ text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
        pageSettings: {pageSize: 10, pageSizes: [10,50,100,200], pageCount: 10 },  
        filterSettings: { type: 'Excel' },     
        theme: theme,       
        theme2:theme2,
        theme3: theme2,
        primaryXAxis: {
          minimum : new Date(1971,6,11), maximum : new Date(2012,6,11), valueType: 'DateTime', edgeLabelPlacement: 'Shift', majorGridLines: { width: 0 }
        },
      
        chartArea: {
          border: {
            width: 0
          }
        },  
        width : Browser.isDevice ? '100%' : '75%',
        marker: {
          visible: true,
          height: 7,
          width: 7
        },
        tooltip: {
          enable: true,
          header: "<b>Fruit Production</b>",
          showNearestTooltip: true,
          format: '${point.x} : <b> ${point.y} </b>',
        },
        chartArea2: {
          border: {
            width: 0
          }
        },
        dataLabel2: {
          visible: true,
          name: 'data_label_mapping_name',
          position: 'Outside',
          font: {
              fontWeight: '600',                
          },
          connectorStyle: { 
              length: '20px',
              type: 'Curve'
          }
        },
        centerLabel2:{
          text : 'Mobile<br>Browsers<br>Statistics',
          hoverTextFormat: '${point.x} <br> Browser Share <br> ${point.y}%',
          textStyle: {
                fontWeight: '600',
                size: Browser.isDevice ? '8px' : '15px'
            },
        },
        tooltip2: {enable: true ,format:"<b>${point.x}</b><br> Gold Medals: <b>${point.y}</b>" , header:"" },
        radius2: Browser.isDevice ? '40%' : '70%',
        border2: { width: 1 },
        legendSettings2: {
            visible: false,
        },
        startAngle2: Browser.isDevice ? '30' : '62', 
        primaryXAxis3: {
        valueType: 'DateTime', labelFormat: 'yyyy-MM-dd',
            majorGridLines: { width: 0 },
            edgeLabelPlacement: 'Shift'
        },
        title3: '採購比例說明',
        primaryYAxis3: {
          title: '訂單量',
              lineStyle: { width: 2 },
              majorTickLines: { width: 2 },
              minorTickLines: { width: 2 },
              maximum: 500,
              interval: 100
        },
        chartArea3: {
          border: {
            width: 0
          }
        },
     
        tooltip3: {
            enable: true,
            showNearestTooltip: true,
            enableHighlight: true,
            header: '<b>Almond Yield - ${point.x}</b>',
            format: '${series.name}: <b>${point.y}</b>'
        },
        
      };
    },
    provide: {
      chart: [StepLineSeries, ColumnSeries, Legend, DateTime, Category,  Highlight, ChartAnnotation, Tooltip],
      accumulationchart: [AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel],
      grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
    },
    methods: {
      load: function(args) {
          this.theme = loadChartTheme(args);  
      },
      onClickUnitPrice: function() {

          this.datas_chat = this.datas_unit_price;

          this.primaryYAxis3 = {
            title: '採購單價',
                lineStyle: { width: 2 },
                majorTickLines: { width: 2 },
                minorTickLines: { width: 2 },
                maximum:  this.max_unit_price,
                interval: this.max_unit_price / 10
          };
      },
      onClickTotalPrice: function() {
          this.datas_chat = this.datas_total_price;
     
          this.primaryYAxis3 = {
            title: '採購總價',
                lineStyle: { width: 2 },
                majorTickLines: { width: 2 },
                minorTickLines: { width: 2 },
                maximum: this.max_total_price,
                interval: this.max_total_price / 10
          };
      },
      onClickAmount: function() {
        this.datas_chat = this.datas_amount;
  
        this.primaryYAxis3 = {
            title: '採購金額',
                lineStyle: { width: 2 },
                majorTickLines: { width: 2 },
                minorTickLines: { width: 2 },
                maximum: this.max_amount,
                interval: this.max_amount / 10
          };
      },
      onClickQuity: function() {
        this.datas_chat = this.datas_quity;
     
        this.primaryYAxis3 = {
          title: '採購數量',
              lineStyle: { width: 2 },
              majorTickLines: { width: 2 },
              minorTickLines: { width: 2 },
              maximum: this.max_quity,
              interval: parseInt(this.max_quity / 10)
        };
      },
      getCustomer: function(no) {    
        this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/Detail?no=${no}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
          this.datas_list = response.data.datas.list;
          this.datas_proportion =  response.data.datas.proportion;       
          this.datas_header = response.data.datas.header;
          this.datas_unit_price = response.data.datas.content_unit_price;
          this.datas_total_price = response.data.datas.content_total_price;
          this.datas_amount = response.data.datas.content_amount;
          this.datas_quity = response.data.datas.content_quity;
          this.max_unit_price = response.data.datas.max_unit_price;
          this.max_total_price = response.data.datas.max_total_price;
          this.max_amount = response.data.datas.max_amount;
          this.max_quity = response.data.datas.max_quity;
          this.onClickUnitPrice();
        })
        .catch((error) => { 
          this.showError(error) }
        )             
      },    
      onQueryCellInfo(args) {     
        if (args.cell) {
          args.cell.classList.add("tooltip-cell");
          args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
        }
      },
      pointRender2: function(args) {
        donutPointRender(args);
      }  
    },
     created() {
        const no = this.$route.query.no;
        this.getCustomer(no);
    },
  };
  </script>

  <style>
@font-face {
    font-family: 'e-bg-icons';
    src:
    url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype');
    font-weight: normal;
    font-style: normal;
}

.sb-bg-icons {
    font-family: 'e-bg-icons' !important;
    speak: none;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.e-btngrp-watch::before {
    content: '\e71b';
}
    
.e-btngrp-star::before {
    content: '\e710';
}
    
.e-btngrp-download::before {
    content: '\e712';
}
    
.e-btngrp-bold::before {
    content: '\e71a'
}
    
.e-btngrp-italic::before {
    content: '\e708';
}
    
.e-btngrp-underline::before {
    content: '\e703';
}
</style>